module.exports = __webpack_public_path__ + "img/500.b290810b.png";